<template>
  <div
    class="product-standout"
    :style="{
      'background-color': backgroundColor,
    }"
  >
    <div class="container">
      <div class="grid">
        <div class="column column--text">
          <div class="info">
            <div class="info__inner">
              <slot name="content"></slot>
            </div>
          </div>
        </div>
        <div class="column">
          <ProductByHandleQueryWrapper
            v-slot="{ product }"
            :handle="productHandle"
          >
            <ProductCard
              v-if="product"
              :product="product"
              :media="{
                sources: [
                  {
                    url: productVideoUrl,
                  },
                ],
              }"
              class="primary-product"
            />
          </ProductByHandleQueryWrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductByHandleQueryWrapper from "@/components/ProductByHandleQueryWrapper.vue";
import ProductCard from "@/components/ProductCard.vue";

export default {
  name: "ProductStandout",
  components: {
    ProductByHandleQueryWrapper,
    ProductCard,
  },
  props: {
    productHandle: {
      type: String,
      required: true,
    },
    productVideoUrl: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.column {
  padding: 80px 0;

  &--text {
    padding: 80px;
  }
}

.info {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  :deep(p) {
    @include editorial-body(14px);
    margin-bottom: 20px;
  }

  :deep(h3) {
    margin-bottom: 20px;
    @include editorial-headline(36px);
    text-transform: uppercase;
  }

  :deep(.button) {
    display: inline-block;
  }
}
</style>
